"use client";

import React from "react";

import { iconColor } from "./colors";
import { createSVGIcon } from "./createSVGIcon";
import { iconCls } from "./tracking";

/**
 * @figma designed by Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=1160%3A439))
 * @lastsynced 2026-10-29T13:53:56.742Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const StarHalf = createSVGIcon(
  <>
    <path
      d="M11.566 19.69a.94.94 0 0 1 .437-.108V1.35a.94.94 0 0 0-.843.524l-2.714 5.5a.94.94 0 0 1-.708.515l-6.079.89a.94.94 0 0 0-.514 1.603l4.389 4.289a.94.94 0 0 1 .269.831l-1.037 6.055a.94.94 0 0 0 1.37.99z"
      fill="#333"
    />
    <mask id="stroke0_1160_439" fill="#fff">
      <path d="m15.56 7.375-2.713-5.501a.941.941 0 0 0-1.687 0L9 13l2.197 6.884.37-.194a.94.94 0 0 1 .873 0l5.416 2.848a.94.94 0 0 0 1.371-.99l-1.037-6.054a.94.94 0 0 1 .27-.832l4.395-4.286a.939.939 0 0 0-.515-1.602l-6.072-.885a.94.94 0 0 1-.708-.514" />
    </mask>
    <path
      d="m12.847 1.874 2.713 5.5a.94.94 0 0 0 .708.515l6.072.885a.94.94 0 0 1 .515 1.602l-4.396 4.286a.94.94 0 0 0-.269.831l1.037 6.055a.94.94 0 0 1-1.371.99L12.44 19.69a.94.94 0 0 0-.874 0l-.369.194L9 13l2.16-11.126a.94.94 0 0 1 1.687 0Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="#333"
      mask="url(#stroke0_1160_439)"
    />
  </>,
  "StarHalf",
  {
    className: iconCls(),
    color: iconColor.primary,
    fill: "none",
    viewBox: "0 0 24 24",
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
